// extracted by mini-css-extract-plugin
module.exports = {"container":"vxyb-Ut_VW6AnBx9wlThw"};